import React, {useContext} from 'react'

//Node Modules
import { DomElement } from 'html-react-parser'

//Context
import { ToggleUnavailableContext } from 'context/content-context'

//Components
import Meta from 'components/xis/Meta'

//Util
import { CheckFlags } from 'util/feature-flags'

export default ({ attribs }:DomElement, params:any, options:any) => {
  const empty = <></>

  if (!attribs) {
    // Not attributes
    return empty
  }

  const name = attribs && attribs['name']
  const content = attribs && attribs['content'] 
  
  if (!name || !content) {
    // Required properties not found
    return empty
  }

  if (content === 'noindex' || content === 'none') {
    return <meta name={name} content={content} />
  }

  if ( name === 'featureFlags') {
    const toggleUnavailableContext = useContext(ToggleUnavailableContext)
    const flags = content.split(',') as String[]

    for (let flag of flags) {
      if (!CheckFlags(flag.trim()) ) {
        toggleUnavailableContext.toggleUnavailable(content)
        return
      }
    }

  } //check for feature flags

  return <Meta name={name} content={content} />
}